import { useFormikContext } from "formik";
import React from "react";

import styles from "./FormError.module.css";

/** Renders the Formik form-level status string as a danger banner (used for API/submit errors). */
const FormError = () => {
	const { status } = useFormikContext();

	if (!status || typeof status !== "string") {
		return null;
	}

	return (
		<div className={styles.error} role="alert">
			{status}
		</div>
	);
};

export default FormError;
